<template>
  <div class="end-banner py-14">
    <div class="title">
      <h2 class="text-center"><span>Why Shop </span> With Us?</h2>
    </div>
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="d-flex align-center justify-center"
        >
          <v-card elevation="0" class="text-center" color="transparent">
            <div>
              <img src="../../images/free-shipping.png" alt="Free Shipping" />
            </div>
            <v-card-title
              class="text"
              style="color: white; font-size: 20px; font-weight: bold"
            >
              Free Shipping on First Order
            </v-card-title>
            <v-card-text style="color: white">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </v-card-text>
            <a href="#" style="color: white">Learn More</a>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="d-flex align-center justify-center"
        >
          <v-card elevation="0" class="text-center" color="transparent">
            <div>
              <img
                src="../../images/weekly-flash-sales.png"
                alt="Weekly Flash Sales"
              />
            </div>
            <v-card-title
              class="text"
              style="color: white; font-size: 20px; font-weight: bold"
            >
              Weekly Flash Sale
            </v-card-title>
            <v-card-text style="color: white">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </v-card-text>
            <a href="#" style="color: white">Learn More</a>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="d-flex align-center justify-center"
        >
          <v-card elevation="0" class="text-center" color="transparent">
            <div>
              <img
                src="../../images/discount.png"
                alt="Annual Payment Discount"
              />
            </div>
            <v-card-title
              class="text"
              style="color: white; font-size: 20px; font-weight: bold"
            >
              Annual Payment Discount
            </v-card-title>
            <v-card-text style="color: white">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </v-card-text>
            <a href="#" style="color: white">Learn More</a>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="d-flex align-center justify-center"
        >
          <v-card elevation="0" class="text-center" color="transparent">
            <div>
              <img
                src="../../images/cash-back.png"
                alt="Cashback Reward Program"
              />
            </div>
            <v-card-title
              class="text"
              style="color: white; font-size: 20px; font-weight: bold"
            >
              Cashback Reward Program
            </v-card-title>
            <v-card-text style="color: white">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </v-card-text>
            <a href="#" style="color: white">Learn More</a>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style scoped lang="css">
.end-banner {
  background-image: url(../../images/why-shop-with-us-banner.webp);
  background-repeat: repeat-x;
  background-size: cover;
}
.end-banner h2 {
  font-size: 35px;
  color: white;
  letter-spacing: 6px;
}

.end-banner h2 span {
  font-weight: 800;
  background: linear-gradient(65deg, #0dc3ff, #67d767, #ffb300);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-transform: uppercase;
}
</style>
